import {
	type CommandConstructor,
	type CommandProperties,
	type SerializableValue,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

/**
 * Properties for the Jira items creation command.
 *
 * @extends CommandProperties
 */
export interface JiraDeclineItemCommandProperties extends CommandProperties {
	/**
	 * The invocation ID of the declined item
	 */
	invocationId: string;
}

/**
 * A command sent by a bridge API client to indicate that Jira items have been declined.
 *
 * @summary {@link CommandProperties.senderId} is notifying {@link CommandProperties.receiverId} that Jira items have been declined with the specified content.
 */
export const JiraDeclineItemCommand: CommandConstructor<
	JiraDeclineItemCommandProperties,
	SerializableValue
> = createCommand<JiraDeclineItemCommandProperties>('jira-decline-item-command');
